import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../../../assets/css/student/about/Mission.css';

const OurMission = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="msn-mission-section">
      {/* Animated decorative circles */}
      <div className="mission-deco-circle mission-deco-circle-1"></div>
      <div className="mission-deco-circle mission-deco-circle-2"></div>

      <Container className="msn-mission-container">
        {/* Header Section */}
        <div className={`mission-header ${isVisible ? 'mission-animate-header' : ''}`}>
          <div className="mission-badge">
            <h1>OUR MISSION</h1>
          </div>
          
          <h2 className="msn-mission-title">
            Making a Difference in the World
          </h2>
          
          <p className="msn-mission-text">
           We are committed to supporting students in need by providing access to education and essential resources.
          </p>
          
          <p className="msn-mission-text">
          Our mission is to empower students who face financial challenges through transparent and secure donation support.
          </p>
          
          <p className="msn-mission-text">
            Together, we can transform lives and give every student the opportunity to succeed.
          </p>
        </div>

        {/* Cards Section */}
        <Row className="g-4 mt-5">
          {/* Card 1 */}
          <Col xs={12} md={4}>
            <div className={`mission-card ${isVisible ? 'mission-animate-left' : ''}`}>
              <div className="mission-card-icon mission-icon-gradient-1">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h3 className="mission-card-title">Our Vision</h3>
              <p className="mission-card-text">
                We aim to make education accessible for every student by providing support for fees, books, and uniforms, creating a better and brighter future.
              </p>
            </div>
          </Col>

          {/* Card 2 */}
          <Col xs={12} md={4}>
            <div className={`mission-card ${isVisible ? 'mission-animate-scale' : ''}`}>
              <div className="mission-card-icon mission-icon-gradient-2">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3 className="mission-card-title">Our Team</h3>
              <p className="mission-card-text">
               Our team is made up of passionate individuals working together to support students through transparency, care, and collaboration.
              </p>
            </div>
          </Col>

          {/* Card 3 */}
          <Col xs={12} md={4}>
            <div className={`mission-card ${isVisible ? 'mission-animate-right' : ''}`}>
              <div className="mission-card-icon mission-icon-gradient-3">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </div>
              <h3 className="mission-card-title">Our Impact</h3>
              <p className="mission-card-text">
                Through donor support, we help students continue their education and create real, positive change in their lives.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default OurMission;
